export default __webpack_public_path__ + "src/images/galleries/2/preface_cn-19b8a6.png";